import { Component } from '@angular/core';
import { GUI } from '../common/gui';

@Component({
  selector: 'app-payment-failure',
  templateUrl: './payment-failure.component.html',
  styleUrls: ['./payment-failure.component.css']
})
export class PaymentFailureComponent {

  constructor(private gui: GUI) { }

  openDashboard(){
    this.gui.openDashboardPage();
  }

}
